
import React from 'react'
import {Link, useRouteError} from 'react-router-dom'
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { Box } from '@mui/material';


const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText('#17cf97'),
    backgroundColor: '#17cf97',
    '&:hover': {
      backgroundColor: '#107456',
    },
  }));

const Error = () => {

    
  const error = useRouteError();

  if(error.status === 404) {
    return <>
      <Box component="div" className='error' sx={{ color: "text.primary" }}>
        <h3  className='errorTitle'>4<span>0</span>4</h3>
        <p>We cannot seem to find a page you are looking for</p>
        <ColorButton variant="contained"><Link className='text-link ' to='/'>BACK Home</Link></ColorButton>
      </Box>
    </>
  }
  return (
      <>
        <div>
        <h3>something went wrong</h3>
      </div>
        </>
  )
}
export default Error